import { Dialog } from "@headlessui/react"
import React, { useEffect, useState } from "react"
import Takedown from "../../../catalog/asset-registry/new-release-action/takedown/Takedown"
import { SelectOption, User, UserTakedown } from "../../../../../types"
import { NewReleaseActions, TakedownActionTabs } from "../../../../../actions/types"

const AdminTakedownMetadataModal = ({
  selectedAlbumIds,
  selectedUser,
  selectedUserTakedown,
  handleClose
}: {
  selectedAlbumIds?: string[]
  selectedUser?: User
  selectedUserTakedown?: UserTakedown
  handleClose: (refreshList: boolean) => void
}) => {
  const [selectedTab, setSelectedTab] = useState(TakedownActionTabs.SELECT_ALBUM)
  const [selectedPage, setSelectedPage] = useState(NewReleaseActions.TAKEDOWN)
  const [selectedTakedownArtist, setSelectedTakedownArtist] = useState<SelectOption>()

  useEffect(() => {
    if (!selectedUser) setSelectedTakedownArtist(undefined)
    setSelectedTakedownArtist({ label: selectedUser?.firstName || "", value: selectedUser?.artistSpotifyId || "" })
  }, [selectedUser])

  return (
    <Dialog open={selectedAlbumIds !== undefined && selectedUser !== undefined} onClose={() => handleClose(false)}>
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d] ">
        <div className="p-6 shadow-md rounded-[10px] bg-[#fff]" style={{ height: "90vh", overflowY: "scroll" }}>
          {selectedUser && selectedAlbumIds && selectedUserTakedown && (
            <Takedown
              user={selectedUser}
              setSelectedPage={setSelectedPage}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              selectedArtist={selectedTakedownArtist}
              setSelectedArtist={setSelectedTakedownArtist}
              selectRelease={() => {}}
              selectedAlbumIds={selectedAlbumIds}
              selectedUserTakedown={selectedUserTakedown}
              onFinishTakedown={() => handleClose(true)}
            />
          )}
        </div>
      </div>
    </Dialog>
  )
}

export default AdminTakedownMetadataModal
